module.exports = __webpack_public_path__ + "static/shareLand2BG-c0c186eb1cc3d239d05d3130392c5635.png";